import { cn } from '@/shared/lib/cn';
import { type SpinnerVariants, spinnerVariants } from './spinner-variants';

type SpinnerProps = SpinnerVariants & { className?: string };

export function Spinner({ size, className }: SpinnerProps) {
  return (
    <span
      data-slot="spinner"
      aria-hidden="true"
      className={cn(spinnerVariants({ size }), className)}
    />
  );
}
